import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '../App.tsx'
import '../styles/globals.css'

function setCanonicalURL() {
  // For SPA deep links, keep canonical aligned with the current path.
  // Avoid including query/hash in canonical.
  const origin = window.location.origin;
  const path = window.location.pathname || '/';
  const canonicalHref = `${origin}${path}`;

  let link = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  link.href = canonicalHref;
}

console.log('🚀 CosmicInvestor Firebase Initialize:', {
  app: 'CosmicInvestor',
  version: '4.0.0',
  environment: import.meta.env.MODE || 'production',
  development: import.meta.env.DEV || false,
  timestamp: new Date().toISOString(),
  authProvider: 'Firebase (Ready for Setup)',
  status: 'Clean Start - No External Auth Dependencies'
});

setCanonicalURL();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)